// @flow
import React from 'react';
import { Link } from 'react-router-dom';

import BackgroundImage from 'components/fragments/BackgroundImage';
// import BillboardMenuLinks from 'components/billboard/BillboardMenuLinks';
import type { ArticleType, CategoryArticleType } from 'types/Article';

type Props = {
  categoriesArticle: CategoryArticleType[],
  news: ArticleType
};

function BillboardHeaderNews({ categoriesArticle, news }: Props) {
  return (
    <section className="news-section">
      <div className="home-slider__wrapper">
        <BackgroundImage
          className="banner__thumbnail img-blue-gradient"
          illustration={news.illustration}
          srcset={news.srcset}
        />
        <div className="home-slider__item container">
          <span className="label label--red mb-4">{news.label.name}</span>
          <h2 className="mb-2 mb-lg-6">
            <a href={news.link}>{news.title}</a>
          </h2>
          <div className="news-section_button-wrapper">
            {news.link && (
              <Link to={news.link} className="">
                <i className="icon icon-chevron-right is-dark is-inline"></i>
                <span>Lire article</span>
              </Link>
            )}
            <Link to={'/actualites'} role="button" tabIndex={0} className={''}>
              <i className="icon icon-chevron-right is-dark is-inline"></i>
              <span>Voir toutes les actualités</span>
            </Link>
          </div>
        </div>
      </div>
      {/* <BillboardMenuLinks categories={categoriesArticle} /> */}
    </section>
  );
}

export default BillboardHeaderNews;
